import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Route guard that verifies the user is an authenticated admin before rendering children.
 * Shows a subtle loading state during the /auth/me check (no 401 flicker to login page).
 */
export default function RequireAdmin({ children }) {
    const [state, setState] = useState("checking"); // 'checking' | 'ok' | 'no'

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then(() => mounted && setState("ok"))
            .catch(() => mounted && setState("no"));
        return () => { mounted = false; };
    }, []);

    if (state === "checking") {
        return (
            <div className="min-h-screen bg-[#0a0a0c] text-white/50 flex items-center justify-center" data-testid="admin-guard-loading">
                <div className="fw-mono text-[10px] uppercase tracking-[0.35em]">Verifying access…</div>
            </div>
        );
    }
    if (state === "no") return <Navigate to="/admin/login" replace />;
    return children;
}
